
import { getFavouriteDeparturesAction } from "../../../Actions/LogicActions/Search/GetFavouriteDeparturesAction";
import { getTrainOfferContinueAction } from "../../../Actions/LogicActions/TrainOffer/GetTrainOfferContinueAction";
import { destinationBookNowAction } from "../../../Actions/UIActions/CMSDestination/DestinationBookNowAction";
import { ExecutionStatus } from "../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree, trainOfferEvtTree } from "../../../Orchestrator/ConstantTree";
import { TrainOfferRequest } from "../../../Orchestrator/Types/Index";
import { ICMSBookNowParams } from "../../../Orchestrator/Types/Interface/ICmsDestination";

export class FavouriteDeparturesStep extends StepFlow {
    get stepName() { return "FavouriteDeparturesStep"; }

    /** Routes where this step's Continue.Click handler should be active. */
    private readonly activeRoutes = ["/", "/search"];

    private isOnActivePage(): boolean {
        if (typeof window === "undefined") return false;
        return this.activeRoutes.includes(window.location.pathname);
    }

    async onEventSetup(): Promise<void> {
        // Disabled — old getFavouriteDeparturesAction makes 3 /retailer/offers calls.
        // Re-enable here if/when the widget is brought back.
        // this.registerEventSubscription(
        //     _eventBus.on({
        //         eventName: evtTree.favouriteDepartures.Get,
        //         handler: async () => {
        //             getFavouriteDeparturesAction.execute();
        //         }
        //     })
        // );

        this.registerEventSubscription(
            _eventBus.on<ICMSBookNowParams, void>({
                eventName: evtTree.DestinationDetail.BookNow.Click,
                handler: async ({ data }) => {
                    if (data) {
                        destinationBookNowAction.setParams(data!);
                        destinationBookNowAction.execute();
                    }
                },
            })
        );

        this.registerEventSubscription(
            _eventBus.on<TrainOfferRequest, void>({
                eventName: trainOfferEvtTree.Offer.Continue.Click,
                handler: async (payload) => {
                    // Only handle Continue.Click when on a page owned by this step.
                    // On other pages (e.g. /train-offer) TicketOptionPageStep owns
                    // this event. Because this step's subscriptions are never torn
                    // down we must guard explicitly.
                    if (!this.isOnActivePage()) return;

                    getTrainOfferContinueAction.setParams(payload.data!);
                    await getTrainOfferContinueAction.execute();
                    if (getTrainOfferContinueAction.status.executionStatus === ExecutionStatus.SUCCESS) {
                        const data = getTrainOfferContinueAction.result!;
                        if (data.returnText === "success" && data.checkoutRedirect == true) {
                            sessionStorage.setItem("checkoutFromWithLogin", "true")

                            this.next()
                            _eventBus.emit({
                                eventName: "ROUTE_CHANGE",
                                data: "/checkout",
                            })
                        }
                    }
                }
            })
        )
    }

    async onExecute(): Promise<void> {
        if (window && window.location.href.includes("/search")) {
            console.log("FavouriteDeparturesStep Init Step Execute...");
            this.eventBus.emit({
                eventName: evtTree.favouriteDepartures.Get,
            });
        }
    }
}
export const favouriteDeparturesStepDeclaration = new StepDefinition({
    stepName: "FavouriteDeparturesStep",
    stepClass: FavouriteDeparturesStep
});
